import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { doc, updateDoc, getDoc } from "firebase/firestore";

export const updateVendorProfile = async (
  db,
  storage,
  auth,
  data,
  setError = null,
  setLoading = null,
  setUploadProgress = null
) => {
  if (setLoading) setLoading(true);
  if (setError) setError("");

  try {
    console.log("Starting profile update...");
    console.log("Update Data:", data);

    // Verify user is authenticated
    const currentUser = auth.currentUser;
    if (!currentUser || !currentUser.uid) {
      throw new Error("User not authenticated. Please sign in again.");
    }

    const uid = currentUser.uid;
    const userRef = doc(db, "vendorUsers", uid);

    // Fetch current data to get old image path
    const currentDoc = await getDoc(userRef);
    const currentData = currentDoc.exists() ? currentDoc.data() : {};
    const originalProfilePicturePath = currentData.profilePicturePath;

    // Helper: upload single file
    const uploadFile = async (file, pathPrefix, description = "file") => {
      return new Promise((resolve, reject) => {
        try {
          const timestamp = new Date().getTime();
          const ext = file.name.split(".").pop();
          const fullPath = `VendorImages/${uid}/${pathPrefix}_${timestamp}.${ext}`;
          const storageRef = ref(storage, fullPath);
          const uploadTask = uploadBytesResumable(storageRef, file);

          uploadTask.on(
            "state_changed",
            (snapshot) => {
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              if (setUploadProgress)
                setUploadProgress(`Uploading ${description}: ${Math.round(progress)}%`);
            },
            (error) => reject(error),
            async () => {
              const url = await getDownloadURL(uploadTask.snapshot.ref);
              resolve({ url, path: fullPath });
            }
          );
        } catch (err) {
          reject(err);
        }
      });
    };

    // Helper: delete old image
    const deleteOldImage = async (oldPath) => {
      if (!oldPath) return;
      try {
        await deleteObject(ref(storage, oldPath));
      } catch (err) {
        console.warn("Failed to delete old profile image:", err);
      }
    };

    // Validate basic fields
    if (!data.firstName || !data.lastName || !data.mobile) {
      throw new Error("First name, last name, and mobile number are required");
    }

    // Upload new profile picture if provided
    let profilePictureUpdate = {};
    if (data.profilePictureFile) {
      if (setUploadProgress) setUploadProgress("Uploading profile picture...");
      const uploaded = await uploadFile(data.profilePictureFile, "profile", "profile picture");
      profilePictureUpdate = {
        profilePicturePath: uploaded.path,
        profilePictureUrl: uploaded.url,
      };
      await deleteOldImage(originalProfilePicturePath);
    }

    // Prepare text field updates
    const textUpdates = {
      firstName: data.firstName,
      lastName: data.lastName,
      mobile: data.mobile,
      countryCode: data.countryCode || "+1",
      city: data.city || "",
      state: data.state || "",
      zip: data.zip || "",
      headquarters: data.headquarters || "",
      updatedAt: new Date().toISOString(),
    };

    // Combine and update Firestore
    const updates = { ...textUpdates, ...profilePictureUpdate };
    await updateDoc(userRef, updates);

    console.log("Profile updated successfully!");
  } catch (err) {
    console.error("Update error:", err);
    throw err;
  } finally {
    if (setLoading) setLoading(false);
    if (setUploadProgress) setUploadProgress("");
  }
};
